import { createActions, createReducer } from 'reduxsauce'

import FuncoesService from '../servicos/FuncaoDespesaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaSubFuncaoInicio: [],
    buscaSubFuncaoSucesso: ['subFuncao'],
    buscaSubFuncaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaSubFuncoes = exercicio => {
    return dispatch => {
        dispatch(Creators.buscaSubFuncaoInicio())
        let serv = new FuncoesService()
        return serv
            .getSubFuncoes(exercicio)
            .then(response => dispatch(Creators.buscaSubFuncaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaSubFuncaoErro(error)))
    }
}

const buscaSubFuncaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaSubFuncaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaSubFuncaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.subFuncao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_SUB_FUNCAO_INICIO]: buscaSubFuncaoInicio,
    [Types.BUSCA_SUB_FUNCAO_ERRO]: buscaSubFuncaoErro,
    [Types.BUSCA_SUB_FUNCAO_SUCESSO]: buscaSubFuncaoSucesso,
})
